import { Provider } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * Base path the {@link provideTranslateHttpLoader} loads translation files from.
 *
 * Defaults to the local assets folder. Point it at a CDN by changing only this
 * constant, e.g.:
 *   export const I18N_BASE_PATH = 'https://cdn.markant.com/service-hub/i18n/';
 */
export const I18N_BASE_PATH = './assets/i18n/';

/** Languages shipped with the application. */
export const SUPPORTED_LANGUAGES = ['de', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/** Language used on first load and as the fallback for missing keys. */
export const DEFAULT_LANGUAGE: SupportedLanguage = 'de';

/**
 * Standalone provider configuration for `@ngx-translate/core`.
 *
 * Uses the `TranslateHttpLoader` (via {@link provideTranslateHttpLoader}) so the
 * translation JSON files are fetched lazily from {@link I18N_BASE_PATH}.
 */
export function provideTranslation(): Provider[] {
  return provideTranslateService({
    lang: DEFAULT_LANGUAGE,
    fallbackLang: DEFAULT_LANGUAGE,
    loader: provideTranslateHttpLoader({
      prefix: I18N_BASE_PATH,
      suffix: '.json',
    }),
  });
}
